import {Component, computed, inject} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DrawerUtils } from '../../../services/drawer-utils';
import {AuthService} from '../../../core/auth/auth-service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public readonly drawerUtils = inject(DrawerUtils);
  public readonly authService = inject(AuthService);

  readonly logoSrc = environment.production ? '/img/logo.png' : '/img/logo-qa.png';

  mail = computed<string>(() => {
    const login = this.authService.loginUser();
    return login?.mail ?? '';
  });

  toggleDrawer() {
    this.drawerUtils.drawerState.set(!this.drawerUtils.drawerState())
  }

  logout(): void {
    this.authService.logout();
  }
}
